import {
  siDocker,
  siKubernetes,
  siDigitalocean,
  siApachekafka,
  siGo,
  siPython,
  siRedis,
  siAnsible,
  siTerraform,
  siApple
} from 'simple-icons';

// const createImageIcon = (src: any, alt: any) => (
//   <img src={src} alt={alt} className="w-12 h-12 object-contain" />
// );

const createIcon = (icon: any) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-8 h-8">
    <path d={icon.path} />
  </svg>
);

const TechIcons = {
  Docker: createIcon(siDocker),
  // AWS: createImageIcon('file:///Users/anshumanrohella/Downloads/aws-svgrepo-com-2.svg', 'AWS'),
  Kubernetes: createIcon(siKubernetes),
  DigitalOcean: createIcon(siDigitalocean),
  Kafka: createIcon(siApachekafka),
  Go: createIcon(siGo),
  Python: createIcon(siPython),
  Redis: createIcon(siRedis),
  Ansible: createIcon(siAnsible),
  Terraform: createIcon(siTerraform),
  Apple: createIcon(siApple)
};

export default TechIcons;